module.exports = __webpack_public_path__ + "img/laz.966e6d2b.png";